<template>
	<PullTo
		v-bind="$attrs"
		v-on="$listeners"
		:is-bottom-bounce="false"
		:is-top-bounce="on_top">

		<template #top-block="{ state }">
			<div class="d-flex justify-center">
				<v-icon
					v-if="state === 'pull' || state === 'trigger'"
					large>
					mdi-chevron-down
				</v-icon>

				<v-progress-circular
					v-if="state === 'loading'"
					indeterminate>
				</v-progress-circular>
			</div>
		</template>

		<slot></slot>

	</PullTo>
</template>

<script>
import PullTo from 'vue-pull-to'

export default {
	components: {
		PullTo,
	},
	data: () => ({
		on_top: true,
	}),
	methods: {
		onScroll() {
			this.on_top = window.pageYOffset === 0
		},
	},
	mounted() {
		window.addEventListener('scroll', this.onScroll)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.onScroll)
	},
}
</script>